import React from "react";
import paths, { rootPaths } from "./paths";
import { Navigate, createBrowserRouter } from "react-router-dom";

import OsirisLayout from "layouts/OsirisLayout";
import HorusLayout from "layouts/HorusLayout";
import App from "App";

import Dashboard from "components/pages/horus/dashboard";
import AddDatasetPageHorus from "components/pages/horus/dataset/add";
import AddComputationPageHorus from "components/pages/horus/computation/add";

import ErrorLayout from "../layouts/ErrorLayout";
import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import Login from "components/authentication/card/Login";
import Logout from "components/authentication/card/Logout";
import ForgetPassword from "components/authentication/card/ForgetPassword";
import ConfirmMail from "components/authentication/card/ConfirmMail";
import SolutionsShowcase from "components/pages/SolutionsShowcase";
import AddComputationPageOsiris from "components/pages/osiris/computation/add/index";
import ComputationCharts from "components/pages/osiris/computation/charts/index";
import ComputationAnalysis from "components/pages/osiris/computation/analysis/index";
import ComputationResult from "components/pages/osiris/computation/result/Result";
import ControlCharts from "components/pages/osiris/control/charts/index";
import ControlAnalysis from "components/pages/osiris/control/analysis/index";
import ControlResult from "components/pages/osiris/control/result/Result";
import VariationAnalysisResult from "components/pages/osiris/variation-analysis/result/Result";
import AddDatasetPageOsiris from "components/pages/osiris/dataset/add/index";
import VariationAnalysisAdd from "components/pages/osiris/variation-analysis/add/index";
import VariationAnalysisCharts from "components/pages/osiris/variation-analysis/charts/index";
import VariationAnalysis from "components/pages/osiris/variation-analysis/analysis/index";
import Feedback from "components/common/pyramid/Feedback";
import DashboardCharts from "components/pages/osiris/dashboard/index";

/* Horus */
import ComputationChartsHorus from "components/pages/horus/computation/charts/index";
import ControlChartsHorus from "components/pages/horus/control/charts/index";
import ComputationResultHorus from "components/pages/horus/computation/result/index";
import ControlResultHorus from "components/pages/horus/control/result/index";
import ComputationAnalysisHorus from "components/pages/horus/computation/analysis/index";
import ControlAnalysisHorus from "components/pages/horus/control/analysis";
import VariationAnalysisAddHorus from "components/pages/horus/variation-analysis/add/index";
import VariationAnalysisChartsHorus from "components/pages/horus/variation-analysis/charts/index";
import VariationAnalysisAnalysisHorus from "components/pages/horus/variation-analysis/analysis/index";
import VariationAnalysisResultHorus from "components/pages/horus/variation-analysis/result/index";

const routes = [
  {
    element: <App />,
    children: [
      /* Authentication */
      {
        path: "/", // Route de base pour l'authentification
        //element: <AuthSplitLayout />,
        children: [
          {
            index: true, // Route par défaut (affiche SimpleLogin)
            element: <Login />, //element: <SimpleLogin />
          },
          {
            path: paths.login, // Route pour l'authentification spécifique
            element: <Login />,
          },
          {
            path: paths.logout,
            element: <Logout />,
          },
          {
            path: paths.forgotPassword,
            element: <ForgetPassword />,
          },
          {
            path: paths.confirmMail,
            element: <ConfirmMail />,
          },
          {
            path: paths.solutionsShowcase,
            element: <SolutionsShowcase />,
          },
        ],
      },
      /* Osiris */
      {
        path: rootPaths.osirisRoot,
        element: <OsirisLayout />,
        children: [
          {
            index: true,
            element: <DashboardCharts />,
          },
          {
            /*Dashboard*/
            path: paths.osirisDashboard,
            element: <DashboardCharts />,
          },
          {
            /*Dataset*/
            path: paths.osirisDatasetAdd,
            element: <AddDatasetPageOsiris />,
          },
          {
            /*Computation*/
            path: rootPaths.osirisComputationRoot,
            children: [
              /* Add */
              {
                path: paths.osirisComputationAdd,
                // element: <Computation />,
                element: <AddComputationPageOsiris />,
              },
              /* Charts */
              {
                path: paths.osirisComputationCharts,
                element: <ComputationCharts />,
              },
              /* Analysis */
              {
                path: paths.osirisComputationAnalysis,
                element: <ComputationAnalysis />,
              },
              /* Result */
              {
                path: paths.osirisComputationResult,
                element: <ComputationResult />,
              },
            ],
          },
          {
            /*Control*/
            path: rootPaths.osirisControlRoot,
            children: [
              /* Charts */
              {
                path: paths.osirisControlCharts,
                element: <ControlCharts />,
              },
              /* Analysis */
              {
                path: paths.osirisControlAnalysis,
                element: <ControlAnalysis />,
              },
              /* Result */
              {
                path: paths.osirisControlResult,
                element: <ControlResult />,
              },
            ],
          },
          {
            /*Variation Analysis*/
            path: rootPaths.osirisVariationAnalysisRoot,
            children: [
              /* Add */
              {
                path: paths.osirisVariationAnalysisAdd,
                element: <VariationAnalysisAdd />,
              },
              /* Charts */
              {
                path: paths.osirisVariationAnalysisCharts,
                element: <VariationAnalysisCharts />,
              },
              /* Analysis */
              {
                path: paths.osirisVariationAnalysisAnalysis,
                element: <VariationAnalysis />,
              },
              /* Result */
              {
                path: paths.osirisVariationAnalysisResult,
                element: <VariationAnalysisResult />,
              },
            ],
          },
          /* Feedback */
          {
            path: rootPaths.feedbackRoot,
            element: <Feedback />,
          },
        ],
      },
      /* Horus */
      {
        path: rootPaths.horusRoot,
        element: <HorusLayout />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            /*Dashboard*/
            path: paths.horusDashboard,
            element: <Dashboard />,
          },
          {
            /*Dataset*/
            path: paths.horusDatasetAdd,
            element: <AddDatasetPageHorus />,
          },
          {
            /*Computation*/
            path: rootPaths.horusComputationRoot,
            children: [
              /* Add */
              {
                path: paths.horusComputationAdd,
                // element: <Computation />,
                element: <AddComputationPageHorus />,
              },
              {
                path: paths.horusComputationCharts,
                element: <ComputationChartsHorus />,
              },
              {
                path: paths.horusComputationAnalysis,
                element: <ComputationAnalysisHorus />,
              },
              /* Result */
              {
                path: paths.horusComputationResult,
                element: <ComputationResultHorus />,
              },
            ],
          },
          {
            /*Control*/
            path: rootPaths.horusControlRoot,
            children: [
              {
                path: paths.horusControlCharts,
                element: <ControlChartsHorus />,
              },
              {
                path: paths.horusControlAnalysis,
                element: <ControlAnalysisHorus />,
              },
              /* Result */
              {
                path: paths.horusControlResult,
                element: <ControlResultHorus />,
              },
            ],
          },
          {
            /*Variation Analysis*/
            path: rootPaths.horusVariationAnalysisRoot,
            children: [
              /* Add */
              {
                path: paths.horusVariationAnalysisAdd,
                element: <VariationAnalysisAddHorus />,
              },
              /* Charts */
              {
                path: paths.horusVariationAnalysisCharts,
                element: <VariationAnalysisChartsHorus />,
              },
              /* Analysis */
              {
                path: paths.horusVariationAnalysisAnalysis,
                element: <VariationAnalysisAnalysisHorus />,
              },
              /* Result */
              {
                path: paths.horusVariationAnalysisResult,
                element: <VariationAnalysisResultHorus />,
              },
            ],
          },
          {
            path: "*",
            element: <Navigate to={paths.error404} replace />,
          },
        ],
      },
      /* Error */
      {
        path: rootPaths.errorsRoot,
        element: <ErrorLayout />,
        children: [
          {
            path: paths.error404,
            element: <Error404 />,
          },
          {
            path: paths.error500,
            element: <Error500 />,
          },
        ],
      },
    ]
  }
];

export const router = createBrowserRouter(routes, {
  basename: import.meta.env.VITE_PUBLIC_URL,
});

export default routes;
